<div class="container elegant-color text-white text-center p-3 my-3">
    <div class="row">
        <div class="col-12">
            <h1 class="c-blue">Custom Web Solutions Blog</h1>
            <p>Our views on all things web development from helpful tips to the latest industry news.</p>
        </div>
    </div>
</div>
